/**
 * TUVI - Helpers para búsquedas flexibles
 * Normaliza strings para comparar ignorando tildes, mayúsculas y espacios extra
 */

/**
 * Normaliza un string: quita tildes, pasa a minúsculas, trim y colapsa espacios
 * @param {string} s
 * @returns {string}
 */
export const normalize = (s) => {
  if (s === null || s === undefined) return '';
  return String(s)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
};

/**
 * Comprueba si el texto contiene el término (búsqueda flexible)
 * @param {string} texto - texto donde buscar
 * @param {string} termino - término a buscar
 * @returns {boolean}
 */
export const matchesSearch = (texto, termino) => {
  if (!termino) return true;
  return normalize(texto).includes(normalize(termino));
};

/**
 * Busca si CUALQUIERA de los campos del objeto hace match con el término
 * @param {object} obj - objeto a evaluar
 * @param {string[]} campos - lista de campos a buscar
 * @param {string} termino - término a buscar
 * @returns {boolean}
 */
export const matchesAnyField = (obj, campos, termino) => {
  if (!termino || !obj) return true;
  const t = normalize(termino);
  return campos.some(c => normalize(obj[c]).includes(t));
};
